import type { NodeRecord, Overview } from "./api.js";

export function edgeStatus(nodes: ReadonlyArray<Pick<NodeRecord, "status">>): { label: string; detail: string; live: boolean } {
  if (nodes.length === 0) return { label: "No Mesh Nodes yet", detail: "Enroll a node to connect your edge", live: false };
  const healthy = nodes.filter((node) => node.status === "healthy").length;
  const allHealthy = healthy === nodes.length;
  return { label: allHealthy ? "Edge connected" : "Edge degraded", detail: `${healthy}/${nodes.length} nodes healthy`, live: allHealthy };
}

export function migrationWave(overview: Pick<Overview, "counts" | "pqc">): { title: string; detail: string } {
  const total = overview.counts.capability_endpoints ?? 0;
  if (total === 0) return { title: "No endpoint capability evidence yet", detail: "Mesh Nodes report what each endpoint supports once enrolled." };
  const ready = overview.pqc.ready_endpoints ?? Math.round((overview.pqc.ready_percent / 100) * total);
  return {
    title: `${ready.toLocaleString("en-US")} of ${total.toLocaleString("en-US")} endpoints are ready for the next wave`,
    detail: "Based on current, unexpired capability evidence.",
  };
}

// A real workspace shows its registered organization name, falling back to the tenant ID.
export function workspaceIdentity(demo: boolean, tenantId: string | undefined, tenantName?: string): { name: string; mark: string } {
  if (demo) return { name: "Acme Corporation", mark: "AC" };
  const name = tenantName?.trim() || tenantId;
  if (!name) return { name: "Workspace", mark: "WS" };
  const parts = name.split(/[^a-z0-9]+/i).filter(Boolean);
  const mark = (parts.length > 1 ? `${parts[0]![0]}${parts[1]![0]}` : name.slice(0, 2)).toUpperCase();
  return { name, mark };
}
